<script setup lang="ts">
defineProps<{
  eventId: number;
}>();

const config = useRuntimeConfig();
</script>

<template>
  <a
    :href="`${config.public.API_SERVER_URL}/events/${eventId}/ics`"
    target="_blank"
    rel="noopener"
    :class="$style.root"
  >
    <Icon
      name="ic:outline-calendar-month"
      :class="$style.icon"
      size="var(--icon-size)"
    />
    <span>Добавить в календарь</span>
  </a>
</template>

<style module lang="scss">
.root {
  display: flex;
  align-items: center;
  gap: var(--space-1-5x);
  text-decoration: none;
  @include text_caption1_caps;
  color: var(--color-red-1);
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.icon {
  --icon-size: 24px;
  color: rgba(31, 31, 31, 0.5);
}

@media (max-width: 599px) {
  .root {
    font-size: 8px;
    letter-spacing: 0.8px;
  }

  .icon {
    --icon-size: 16px;
  }
}
</style>
